import script from "./GlobalGroupDeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalGroupDeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./GlobalGroupDeleteModal.vue?vue&type=style&index=0&id=406a920a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-406a920a"]])

export default __exports__